import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import WalletCard from "./WalletCard";
import { Link } from "react-router-dom";
import { walletData } from "../../../utils/data";

const WalletGrid = () => {


  return (
    <div className="wallet-grid-section ">
      {/* This section displays a grid of wallet services with their descriptions and buttons. */}
      <Container>
        <Row className="my-6">
          <Col className="section-header">
            <h1 className="text-center ">Wallet Services</h1>
            <p className="text-muted section-subtext">Explore our comprehensive suite of cryptocurrency services</p>
          </Col>
        </Row>
        <Row>
          <div className="d-flex flex-wrap justify-content-center gap-4">
            {/* Map through the walletData array and render WalletCard components for each wallet service */}
            {walletData.map((wallet, index) => (
              <div key={index} style={{ maxWidth: "400px", width: "100%" }}>
                <WalletCard {...wallet} />
              </div>
            ))}
          </div>
        </Row>
        <Row className="justify-content-center mt-5">
          <Col xs="auto">
            <Link to="/about" className="btn btn-polygon fw-bold">Read More</Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WalletGrid;
